import { Component, OnInit } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';

@Component({
  selector: 'app-public-profile',
  templateUrl: './public-profile.component.html',
  styleUrls: ['./public-profile.component.css']
})
export class PublicProfileComponent implements OnInit {

  constructor( public mobileNav: MobileNavService) { }

  ngOnInit() {
  }

  onClickMe() {
      console.log('button clicked');
      console.log(this.mobileNav);
        this.mobileNav.showSideNav();
    }

}
